import { Box, Flex } from 'reflexbox';
import * as graphql from 'generated/graphql';
import { useTranslation } from 'react-i18next';

import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';

import { LoadingOverlay, Modal, ScrollArea } from '@mantine/core';
import { Button } from '@treams/treams-ui';

export default function SignModal({
	opened,
	onDismiss,
	conversationID,
}: {
	opened: boolean;
	conversationID: string;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const [signConversationMutation, { loading: sharing }] = graphql.useSignConversationMutation({
		refetchQueries: ['Conversation'],
	});

	const handleShare = () => {
		signConversationMutation({
			variables: {
				conversationID,
			},
		}).then(() => {
			onDismiss();
		});
	};

	return (
		<Modal
			title={t('evaluation.submission.confirm.modal.title')}
			opened={opened}
			onClose={onDismiss}
			size="lg"
			scrollAreaComponent={ScrollArea.Autosize}
		>
			<LoadingOverlay visible={sharing} />
			<Paragraph>{t('evaluation.submission.confirm.modal.description')}</Paragraph>
			<Flex px={3} alignItems="center" justifyContent="flex-end">
				<Box mr={2}>
					<Button
						onClick={onDismiss}
						type="secondary"
						title={t('evaluation.submission.confirm.modal.cancel')}
					/>
				</Box>
				<Button onClick={handleShare} title={t('evaluation.submission.confirm.modal.confirm')} />
			</Flex>
		</Modal>
	);
}
